const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["vendors.js","liquid-renderer.js"])))=>i.map(i=>d[i]);
import { _ as __vitePreload } from "./preload-helper.js";
(async () => {
  const { Liquid, LiquidRenderer } = await __vitePreload(async () => {
    const { Liquid: Liquid2, LiquidRenderer: LiquidRenderer2 } = await import("./vendors.js");
    return { Liquid: Liquid2, LiquidRenderer: LiquidRenderer2 };
  }, true ? __vite__mapDeps([0,1]) : void 0);
  const engine = new Liquid();
  class StoreInformations extends HTMLElement {
    constructor() {
      super();
      this.bindEvents = this.bindEvents.bind(this);
      this.el = this;
      this.mapToken = "pk.eyJ1IjoidGhpZWJhdWxkdGdjZCIsImEiOiJjbDRpbTQxb3AwNGM5M2txZm83Y216a3V5In0.3dyl3PtFzuo_nBa5-2gFhw";
      this.marker_image = window.settings.store_locator.marker_image;
      this.marker_reseller = window.settings.store_locator.marker_reseller;
      this.csv = window.settings.store_locator.file;
      this.imageMarkerId = "store";
      this.resellerMarkerId = "reseller";
      this.storeMarkerId = "unclustered-point";
      this.ROUTE_URL = "https://www.google.com/maps/dir/?api=1";
      this.liquidRenderer = new LiquidRenderer(engine);
      this.bindEvents();
    }
    bindEvents() {
      this.loadStores();
    }
    initStore(json) {
      const jsonStores = json.data;
      const jsonStore = jsonStores.filter((store) => this.handleize(store.name) == this.el.dataset.storeHandle);
      const storeHTMLDocument = this.getStoreElement(jsonStore[0]);
      const storeEl = storeHTMLDocument.querySelector(".store-informations");
      const arrayDay = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      const date = /* @__PURE__ */ new Date();
      const day = date.getDay();
      let openingHours = jsonStore[0][arrayDay[day]];
      if (openingHours != null && openingHours != "") {
        openingHours = openingHours.replace(/\s/g, "");
        storeEl.dataset.open = openingHours;
      } else {
        storeEl.dataset.open = "closed";
      }
      this.initializeOpenStatus(storeEl, day);
      this.el.insertAdjacentElement("afterbegin", storeEl);
      this.initMap([Number(jsonStore[0].long), Number(jsonStore[0].lat)], jsonStore[0].type);
      const openRouteButton = this.el.querySelector(".js-open-route");
      if (openRouteButton) {
        openRouteButton.addEventListener("click", (e) => {
          const destinationEncoded = encodeURI(e.currentTarget.closest(".store-informations").dataset.routeAddress);
          window.open(this.ROUTE_URL + "&destination=" + destinationEncoded);
        });
      }
    }
    initMap(coordinatesPoints, type) {
      mapboxgl.accessToken = this.mapToken;
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/light-v10",
        center: coordinatesPoints,
        zoom: 12.3
      });
      this.map.scrollZoom.disable();
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.on("load", () => {
        this.map.addSource("store", {
          type: "geojson",
          "data": {
            "type": "FeatureCollection",
            "features": [
              {
                "type": "Feature",
                "geometry": {
                  "type": "Point",
                  "coordinates": coordinatesPoints
                },
                "properties": {
                  "type": type
                }
              }
            ]
          }
        });
        this.map.loadImage(this.marker_image, (error, image) => {
          if (error) throw error;
          this.map.addImage(this.imageMarkerId, image, {
            pixelRatio: 1
          });
        });
        this.map.loadImage(this.marker_reseller, (error, image) => {
          if (error) throw error;
          this.map.addImage(this.resellerMarkerId, image, {
            pixelRatio: 1
          });
        });
        this.map.addLayer({
          id: this.storeMarkerId,
          type: "symbol",
          source: "store",
          filter: ["!", ["has", "point_count"]],
          layout: {
            "icon-image": ["get", "type"]
          }
        });
      });
    }
    handleize(str) {
      const Latinise = {};
      Latinise.latin_map = { "Á": "A", "Ă": "A", "Ắ": "A", "Ặ": "A", "Ằ": "A", "Ẳ": "A", "Ẵ": "A", "Ǎ": "A", "Â": "A", "Ấ": "A", "Ậ": "A", "Ầ": "A", "Ẩ": "A", "Ẫ": "A", "Ä": "A", "Ǟ": "A", "Ȧ": "A", "Ǡ": "A", "Ạ": "A", "Ȁ": "A", "À": "A", "Ả": "A", "Ȃ": "A", "Ā": "A", "Ą": "A", "Å": "A", "Ǻ": "A", "Ḁ": "A", "Ⱥ": "A", "Ã": "A", "Ꜳ": "AA", "Æ": "AE", "Ǽ": "AE", "Ǣ": "AE", "Ꜵ": "AO", "Ꜷ": "AU", "Ꜹ": "AV", "Ꜻ": "AV", "Ꜽ": "AY", "Ḃ": "B", "Ḅ": "B", "Ɓ": "B", "Ḇ": "B", "Ƀ": "B", "Ƃ": "B", "Ć": "C", "Č": "C", "Ç": "C", "Ḉ": "C", "Ĉ": "C", "Ċ": "C", "Ƈ": "C", "Ȼ": "C", "Ď": "D", "Ḑ": "D", "Ḓ": "D", "Ḋ": "D", "Ḍ": "D", "Ɗ": "D", "Ḏ": "D", "ǲ": "D", "ǅ": "D", "Đ": "D", "Ƌ": "D", "Ǳ": "DZ", "Ǆ": "DZ", "É": "E", "Ĕ": "E", "Ě": "E", "Ȩ": "E", "Ḝ": "E", "Ê": "E", "Ế": "E", "Ệ": "E", "Ề": "E", "Ể": "E", "Ễ": "E", "Ḙ": "E", "Ë": "E", "Ė": "E", "Ẹ": "E", "Ȅ": "E", "È": "E", "Ẻ": "E", "Ȇ": "E", "Ē": "E", "Ḗ": "E", "Ḕ": "E", "Ę": "E", "Ɇ": "E", "Ẽ": "E", "Ḛ": "E", "Ꝫ": "ET", "Ḟ": "F", "Ƒ": "F", "Ǵ": "G", "Ğ": "G", "Ǧ": "G", "Ģ": "G", "Ĝ": "G", "Ġ": "G", "Ɠ": "G", "Ḡ": "G", "Ǥ": "G", "Ḫ": "H", "Ȟ": "H", "Ḩ": "H", "Ĥ": "H", "Ⱨ": "H", "Ḧ": "H", "Ḣ": "H", "Ḥ": "H", "Ħ": "H", "Í": "I", "Ĭ": "I", "Ǐ": "I", "Î": "I", "Ï": "I", "Ḯ": "I", "İ": "I", "Ị": "I", "Ȉ": "I", "Ì": "I", "Ỉ": "I", "Ȋ": "I", "Ī": "I", "Į": "I", "Ɨ": "I", "Ĩ": "I", "Ḭ": "I", "Ꝺ": "D", "Ꝼ": "F", "Ᵹ": "G", "Ꞃ": "R", "Ꞅ": "S", "Ꞇ": "T", "Ꝭ": "IS", "Ĵ": "J", "Ɉ": "J", "Ḱ": "K", "Ǩ": "K", "Ķ": "K", "Ⱪ": "K", "Ꝃ": "K", "Ḳ": "K", "Ƙ": "K", "Ḵ": "K", "Ꝁ": "K", "Ꝅ": "K", "Ĺ": "L", "Ƚ": "L", "Ľ": "L", "Ļ": "L", "Ḽ": "L", "Ḷ": "L", "Ḹ": "L", "Ⱡ": "L", "Ꝉ": "L", "Ḻ": "L", "Ŀ": "L", "Ɫ": "L", "ǈ": "L", "Ł": "L", "Ǉ": "LJ", "Ḿ": "M", "Ṁ": "M", "Ṃ": "M", "Ɱ": "M", "Ń": "N", "Ň": "N", "Ņ": "N", "Ṋ": "N", "Ṅ": "N", "Ṇ": "N", "Ǹ": "N", "Ɲ": "N", "Ṉ": "N", "Ƞ": "N", "ǋ": "N", "Ñ": "N", "Ǌ": "NJ", "Ó": "O", "Ŏ": "O", "Ǒ": "O", "Ô": "O", "Ố": "O", "Ộ": "O", "Ồ": "O", "Ổ": "O", "Ỗ": "O", "Ö": "O", "Ȫ": "O", "Ȯ": "O", "Ȱ": "O", "Ọ": "O", "Ő": "O", "Ȍ": "O", "Ò": "O", "Ỏ": "O", "Ơ": "O", "Ớ": "O", "Ợ": "O", "Ờ": "O", "Ở": "O", "Ỡ": "O", "Ȏ": "O", "Ꝋ": "O", "Ꝍ": "O", "Ō": "O", "Ṓ": "O", "Ṑ": "O", "Ɵ": "O", "Ǫ": "O", "Ǭ": "O", "Ø": "O", "Ǿ": "O", "Õ": "O", "Ṍ": "O", "Ṏ": "O", "Ȭ": "O", "Ƣ": "OI", "Ꝏ": "OO", "Ɛ": "E", "Ɔ": "O", "Ȣ": "OU", "Ṕ": "P", "Ṗ": "P", "Ꝓ": "P", "Ƥ": "P", "Ꝕ": "P", "Ᵽ": "P", "Ꝑ": "P", "Ꝙ": "Q", "Ꝗ": "Q", "Ŕ": "R", "Ř": "R", "Ŗ": "R", "Ṙ": "R", "Ṛ": "R", "Ṝ": "R", "Ȑ": "R", "Ȓ": "R", "Ṟ": "R", "Ɍ": "R", "Ɽ": "R", "Ꜿ": "C", "Ǝ": "E", "Ś": "S", "Ṥ": "S", "Š": "S", "Ṧ": "S", "Ş": "S", "Ŝ": "S", "Ș": "S", "Ṡ": "S", "Ṣ": "S", "Ṩ": "S", "Ť": "T", "Ţ": "T", "Ṱ": "T", "Ț": "T", "Ⱦ": "T", "Ṫ": "T", "Ṭ": "T", "Ƭ": "T", "Ṯ": "T", "Ʈ": "T", "Ŧ": "T", "Ɐ": "A", "Ꞁ": "L", "Ɯ": "M", "Ʌ": "V", "Ꜩ": "TZ", "Ú": "U", "Ŭ": "U", "Ǔ": "U", "Û": "U", "Ṷ": "U", "Ü": "U", "Ǘ": "U", "Ǚ": "U", "Ǜ": "U", "Ǖ": "U", "Ṳ": "U", "Ụ": "U", "Ű": "U", "Ȕ": "U", "Ù": "U", "Ủ": "U", "Ư": "U", "Ứ": "U", "Ự": "U", "Ừ": "U", "Ử": "U", "Ữ": "U", "Ȗ": "U", "Ū": "U", "Ṻ": "U", "Ų": "U", "Ů": "U", "Ũ": "U", "Ṹ": "U", "Ṵ": "U", "Ꝟ": "V", "Ṿ": "V", "Ʋ": "V", "Ṽ": "V", "Ꝡ": "VY", "Ẃ": "W", "Ŵ": "W", "Ẅ": "W", "Ẇ": "W", "Ẉ": "W", "Ẁ": "W", "Ⱳ": "W", "Ẍ": "X", "Ẋ": "X", "Ý": "Y", "Ŷ": "Y", "Ÿ": "Y", "Ẏ": "Y", "Ỵ": "Y", "Ỳ": "Y", "Ƴ": "Y", "Ỷ": "Y", "Ỿ": "Y", "Ȳ": "Y", "Ɏ": "Y", "Ỹ": "Y", "Ź": "Z", "Ž": "Z", "Ẑ": "Z", "Ⱬ": "Z", "Ż": "Z", "Ẓ": "Z", "Ȥ": "Z", "Ẕ": "Z", "Ƶ": "Z", "Ĳ": "IJ", "Œ": "OE", "ᴀ": "A", "ᴁ": "AE", "ʙ": "B", "ᴃ": "B", "ᴄ": "C", "ᴅ": "D", "ᴇ": "E", "ꜰ": "F", "ɢ": "G", "ʛ": "G", "ʜ": "H", "ɪ": "I", "ʁ": "R", "ᴊ": "J", "ᴋ": "K", "ʟ": "L", "ᴌ": "L", "ᴍ": "M", "ɴ": "N", "ᴏ": "O", "ɶ": "OE", "ᴐ": "O", "ᴕ": "OU", "ᴘ": "P", "ʀ": "R", "ᴎ": "N", "ᴙ": "R", "ꜱ": "S", "ᴛ": "T", "ⱻ": "E", "ᴚ": "R", "ᴜ": "U", "ᴠ": "V", "ᴡ": "W", "ʏ": "Y", "ᴢ": "Z", "á": "a", "ă": "a", "ắ": "a", "ặ": "a", "ằ": "a", "ẳ": "a", "ẵ": "a", "ǎ": "a", "â": "a", "ấ": "a", "ậ": "a", "ầ": "a", "ẩ": "a", "ẫ": "a", "ä": "a", "ǟ": "a", "ȧ": "a", "ǡ": "a", "ạ": "a", "ȁ": "a", "à": "a", "ả": "a", "ȃ": "a", "ā": "a", "ą": "a", "ᶏ": "a", "ẚ": "a", "å": "a", "ǻ": "a", "ḁ": "a", "ⱥ": "a", "ã": "a", "ꜳ": "aa", "æ": "ae", "ǽ": "ae", "ǣ": "ae", "ꜵ": "ao", "ꜷ": "au", "ꜹ": "av", "ꜻ": "av", "ꜽ": "ay", "ḃ": "b", "ḅ": "b", "ɓ": "b", "ḇ": "b", "ᵬ": "b", "ᶀ": "b", "ƀ": "b", "ƃ": "b", "ɵ": "o", "ć": "c", "č": "c", "ç": "c", "ḉ": "c", "ĉ": "c", "ɕ": "c", "ċ": "c", "ƈ": "c", "ȼ": "c", "ď": "d", "ḑ": "d", "ḓ": "d", "ȡ": "d", "ḋ": "d", "ḍ": "d", "ɗ": "d", "ᶑ": "d", "ḏ": "d", "ᵭ": "d", "ᶁ": "d", "đ": "d", "ɖ": "d", "ƌ": "d", "ı": "i", "ȷ": "j", "ɟ": "j", "ʄ": "j", "ǳ": "dz", "ǆ": "dz", "é": "e", "ĕ": "e", "ě": "e", "ȩ": "e", "ḝ": "e", "ê": "e", "ế": "e", "ệ": "e", "ề": "e", "ể": "e", "ễ": "e", "ḙ": "e", "ë": "e", "ė": "e", "ẹ": "e", "ȅ": "e", "è": "e", "ẻ": "e", "ȇ": "e", "ē": "e", "ḗ": "e", "ḕ": "e", "ⱸ": "e", "ę": "e", "ᶒ": "e", "ɇ": "e", "ẽ": "e", "ḛ": "e", "ꝫ": "et", "ḟ": "f", "ƒ": "f", "ᵮ": "f", "ᶂ": "f", "ǵ": "g", "ğ": "g", "ǧ": "g", "ģ": "g", "ĝ": "g", "ġ": "g", "ɠ": "g", "ḡ": "g", "ᶃ": "g", "ǥ": "g", "ḫ": "h", "ȟ": "h", "ḩ": "h", "ĥ": "h", "ⱨ": "h", "ḧ": "h", "ḣ": "h", "ḥ": "h", "ɦ": "h", "ẖ": "h", "ħ": "h", "ƕ": "hv", "í": "i", "ĭ": "i", "ǐ": "i", "î": "i", "ï": "i", "ḯ": "i", "ị": "i", "ȉ": "i", "ì": "i", "ỉ": "i", "ȋ": "i", "ī": "i", "į": "i", "ᶖ": "i", "ɨ": "i", "ĩ": "i", "ḭ": "i", "ꝺ": "d", "ꝼ": "f", "ᵹ": "g", "ꞃ": "r", "ꞅ": "s", "ꞇ": "t", "ꝭ": "is", "ǰ": "j", "ĵ": "j", "ʝ": "j", "ɉ": "j", "ḱ": "k", "ǩ": "k", "ķ": "k", "ⱪ": "k", "ꝃ": "k", "ḳ": "k", "ƙ": "k", "ḵ": "k", "ᶄ": "k", "ꝁ": "k", "ꝅ": "k", "ĺ": "l", "ƚ": "l", "ɬ": "l", "ľ": "l", "ļ": "l", "ḽ": "l", "ȴ": "l", "ḷ": "l", "ḹ": "l", "ⱡ": "l", "ꝉ": "l", "ḻ": "l", "ŀ": "l", "ɫ": "l", "ᶅ": "l", "ɭ": "l", "ł": "l", "ǉ": "lj", "ſ": "s", "ẜ": "s", "ẛ": "s", "ẝ": "s", "ḿ": "m", "ṁ": "m", "ṃ": "m", "ɱ": "m", "ᵯ": "m", "ᶆ": "m", "ń": "n", "ň": "n", "ņ": "n", "ṋ": "n", "ȵ": "n", "ṅ": "n", "ṇ": "n", "ǹ": "n", "ɲ": "n", "ṉ": "n", "ƞ": "n", "ᵰ": "n", "ᶇ": "n", "ɳ": "n", "ñ": "n", "ǌ": "nj", "ó": "o", "ŏ": "o", "ǒ": "o", "ô": "o", "ố": "o", "ộ": "o", "ồ": "o", "ổ": "o", "ỗ": "o", "ö": "o", "ȫ": "o", "ȯ": "o", "ȱ": "o", "ọ": "o", "ő": "o", "ȍ": "o", "ò": "o", "ỏ": "o", "ơ": "o", "ớ": "o", "ợ": "o", "ờ": "o", "ở": "o", "ỡ": "o", "ȏ": "o", "ꝋ": "o", "ꝍ": "o", "ⱺ": "o", "ō": "o", "ṓ": "o", "ṑ": "o", "ǫ": "o", "ǭ": "o", "ø": "o", "ǿ": "o", "õ": "o", "ṍ": "o", "ṏ": "o", "ȭ": "o", "ƣ": "oi", "ꝏ": "oo", "ɛ": "e", "ᶓ": "e", "ɔ": "o", "ᶗ": "o", "ȣ": "ou", "ṕ": "p", "ṗ": "p", "ꝓ": "p", "ƥ": "p", "ᵱ": "p", "ᶈ": "p", "ꝕ": "p", "ᵽ": "p", "ꝑ": "p", "ꝙ": "q", "ʠ": "q", "ɋ": "q", "ꝗ": "q", "ŕ": "r", "ř": "r", "ŗ": "r", "ṙ": "r", "ṛ": "r", "ṝ": "r", "ȑ": "r", "ɾ": "r", "ᵳ": "r", "ȓ": "r", "ṟ": "r", "ɼ": "r", "ᵲ": "r", "ᶉ": "r", "ɍ": "r", "ɽ": "r", "ↄ": "c", "ꜿ": "c", "ɘ": "e", "ɿ": "r", "ś": "s", "ṥ": "s", "š": "s", "ṧ": "s", "ş": "s", "ŝ": "s", "ș": "s", "ṡ": "s", "ṣ": "s", "ṩ": "s", "ʂ": "s", "ᵴ": "s", "ᶊ": "s", "ȿ": "s", "ɡ": "g", "ᴑ": "o", "ᴓ": "o", "ᴝ": "u", "ť": "t", "ţ": "t", "ṱ": "t", "ț": "t", "ȶ": "t", "ẗ": "t", "ⱦ": "t", "ṫ": "t", "ṭ": "t", "ƭ": "t", "ṯ": "t", "ᵵ": "t", "ƫ": "t", "ʈ": "t", "ŧ": "t", "ᵺ": "th", "ɐ": "a", "ᴂ": "ae", "ǝ": "e", "ᵷ": "g", "ɥ": "h", "ʮ": "h", "ʯ": "h", "ᴉ": "i", "ʞ": "k", "ꞁ": "l", "ɯ": "m", "ɰ": "m", "ᴔ": "oe", "ɹ": "r", "ɻ": "r", "ɺ": "r", "ⱹ": "r", "ʇ": "t", "ʌ": "v", "ʍ": "w", "ʎ": "y", "ꜩ": "tz", "ú": "u", "ŭ": "u", "ǔ": "u", "û": "u", "ṷ": "u", "ü": "u", "ǘ": "u", "ǚ": "u", "ǜ": "u", "ǖ": "u", "ṳ": "u", "ụ": "u", "ű": "u", "ȕ": "u", "ù": "u", "ủ": "u", "ư": "u", "ứ": "u", "ự": "u", "ừ": "u", "ử": "u", "ữ": "u", "ȗ": "u", "ū": "u", "ṻ": "u", "ų": "u", "ᶙ": "u", "ů": "u", "ũ": "u", "ṹ": "u", "ṵ": "u", "ᵫ": "ue", "ꝸ": "um", "ⱴ": "v", "ꝟ": "v", "ṿ": "v", "ʋ": "v", "ᶌ": "v", "ⱱ": "v", "ṽ": "v", "ꝡ": "vy", "ẃ": "w", "ŵ": "w", "ẅ": "w", "ẇ": "w", "ẉ": "w", "ẁ": "w", "ⱳ": "w", "ẘ": "w", "ẍ": "x", "ẋ": "x", "ᶍ": "x", "ý": "y", "ŷ": "y", "ÿ": "y", "ẏ": "y", "ỵ": "y", "ỳ": "y", "ƴ": "y", "ỷ": "y", "ỿ": "y", "ȳ": "y", "ẙ": "y", "ɏ": "y", "ỹ": "y", "ź": "z", "ž": "z", "ẑ": "z", "ʑ": "z", "ⱬ": "z", "ż": "z", "ẓ": "z", "ȥ": "z", "ẕ": "z", "ᵶ": "z", "ᶎ": "z", "ʐ": "z", "ƶ": "z", "ɀ": "z", "ﬀ": "ff", "ﬃ": "ffi", "ﬄ": "ffl", "ﬁ": "fi", "ﬂ": "fl", "ĳ": "ij", "œ": "oe", "ﬆ": "st", "ₐ": "a", "ₑ": "e", "ᵢ": "i", "ⱼ": "j", "ₒ": "o", "ᵣ": "r", "ᵤ": "u", "ᵥ": "v", "ₓ": "x" };
      String.prototype.latinise = function() {
        return this.replace(/[^A-Za-z0-9\[\] ]/g, function(a) {
          return Latinise.latin_map[a] || a;
        });
      };
      String.prototype.latinize = String.prototype.latinise;
      String.prototype.isLatin = function() {
        return this == this.latinise();
      };
      str = str.toLowerCase().latinise();
      const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
      for (let i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
      }
      str = str.replace(/\W+/g, "-");
      if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
      }
      if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
      }
      return str;
    }
    loadStores() {
      Papa.parse(this.csv, {
        download: true,
        header: true,
        dynamicTyping: {
          zip: false
        },
        skipEmptyLines: true,
        complete: (json) => {
          if (typeof this.initStore === "function") {
            this.initStore(json);
          }
        }
      });
    }
    initializeOpenStatus(element, day) {
      const IS_OPEN = 1;
      const IS_CLOSED = 0;
      if (!element.classList.contains("js-open-status") || typeof element.dataset.open === "undefined") {
        throw new Error("Invalid .js-open-status element");
      }
      const date = /* @__PURE__ */ new Date();
      const now = date.getHours() * 60 + date.getMinutes();
      let isOpen = 0;
      if (element.dataset.open == "closed") {
        isOpen = IS_CLOSED;
      } else {
        const openingHours = this.parseOpeningHours(element.dataset.open);
        let storeHasLunchbreak = false;
        Object.keys(openingHours).length == 4 ? storeHasLunchbreak = true : storeHasLunchbreak = false;
        if (!storeHasLunchbreak) {
          const start = openingHours.start.hours * 60 + openingHours.start.minutes;
          const end = openingHours.end.hours * 60 + openingHours.end.minutes;
          if (start <= now && now <= end) {
            isOpen = IS_OPEN;
          } else {
            isOpen = IS_CLOSED;
          }
        } else {
          const start = openingHours.start.hours * 60 + openingHours.start.minutes;
          const end = openingHours.end.hours * 60 + openingHours.end.minutes;
          const pauseStart = openingHours.pauseStart.hours * 60 + openingHours.pauseStart.minutes;
          const pauseEnd = openingHours.pauseEnd.hours * 60 + openingHours.pauseEnd.minutes;
          if (start <= now && now <= end) {
            if (pauseStart <= now && now <= pauseEnd) {
              isOpen = IS_CLOSED;
            } else {
              isOpen = IS_OPEN;
            }
          } else {
            isOpen = IS_CLOSED;
          }
        }
      }
      element.querySelectorAll(".js-day")[day - 1].classList.add(isOpen ? "open" : "closed");
    }
    parseOpeningHours(openingHoursString) {
      let daysParts = [];
      let openingHours = {};
      if (openingHoursString.includes("/")) {
        daysParts = openingHoursString.split("/");
        for (let i = 0; i < daysParts.length; i++) {
          const hoursParts = daysParts[i].split("-").map((range) => {
            let hoursAndMinutes = "";
            if (range.includes("h")) {
              hoursAndMinutes = range.split("h");
            } else if (range.includes("H")) {
              hoursAndMinutes = range.split("H");
            }
            return {
              "hours": hoursAndMinutes[0],
              "minutes": hoursAndMinutes[1]
            };
          });
          if (i == 0) {
            openingHours["start"] = {
              "hours": parseInt(hoursParts[0].hours),
              "minutes": parseInt(hoursParts[0].minutes)
            };
            openingHours["pauseStart"] = {
              "hours": parseInt(hoursParts[1].hours),
              "minutes": parseInt(hoursParts[1].minutes)
            };
          } else {
            openingHours["pauseEnd"] = {
              "hours": parseInt(hoursParts[0].hours),
              "minutes": parseInt(hoursParts[0].minutes)
            };
            openingHours["end"] = {
              "hours": parseInt(hoursParts[1].hours),
              "minutes": parseInt(hoursParts[1].minutes)
            };
          }
        }
      } else {
        const hoursParts = openingHoursString.split("-").map((range) => {
          let hoursAndMinutes = "";
          if (range.includes("h")) {
            hoursAndMinutes = range.split("h");
          } else if (range.includes("H")) {
            hoursAndMinutes = range.split("H");
          }
          return {
            "hours": hoursAndMinutes[0],
            "minutes": hoursAndMinutes[1]
          };
        });
        openingHours = {
          "start": {
            "hours": parseInt(hoursParts[0].hours),
            "minutes": parseInt(hoursParts[0].minutes)
          },
          "end": {
            "hours": parseInt(hoursParts[1].hours),
            "minutes": parseInt(hoursParts[1].minutes)
          }
        };
      }
      return openingHours;
    }
    getStoreElement(store) {
      const element = this.liquidRenderer.render("one-store-element", store);
      return new DOMParser().parseFromString(element, "text/html");
    }
  }
  customElements.define("store-informations", StoreInformations);
})();
